import React from "react";
import { Alert, ArrowLeft, Button } from "@opendate-app/setlist";
import { formatPrice } from "../../../shared/teamCurrencyFormatting";
import { useClassRegistrationCheckoutContext } from "../ClassRegistrationCheckoutContext";

const startOverUrl = (href) => {
  const url = new URL(href);
  url.searchParams.delete("order");
  url.searchParams.delete("paid");
  return `${url.pathname}${url.search}`;
};

const STATE_MESSAGES = {
  paid: { color: "success", text: "You're registered! A receipt is on its way to your email, and each attendee gets their own confirmation with a link to view their registration." },
  failed: { color: "error", text: "Your hold ran out before a payment went through, so your spots were released. You haven't been charged." },
  released: { color: "warning", text: "This order's spots were released, so it can no longer be paid. You haven't been charged." },
  canceled: { color: "warning", text: "The registrations on this order were canceled. Your cancellation email has the details." },
};

const PROCESSING_MESSAGE = "Your payment is still processing. You'll get an email once it's confirmed.";

export const confirmationAnnouncement = (checkout) => {
  if (checkout.orderMissing) return "";
  if (checkout.settled) return checkout.settled === "paid" ? STATE_MESSAGES.paid.text : "";
  return checkout.pollTimedOut ? PROCESSING_MESSAGE : "Confirming your payment…";
};

export default function ConfirmationStep() {
  const { checkout, classUrl, currencyCode } = useClassRegistrationCheckoutContext();
  const status = checkout.orderStatus;
  const settled = checkout.settled && STATE_MESSAGES[checkout.settled];
  const startOver = typeof window === "undefined" ? classUrl : startOverUrl(window.location.href);

  return (
    <div data-testid="checkout-confirmation">
      {checkout.orderMissing && <Alert color="warning" role="alert" description="We couldn't find this order. If you paid, your receipt email has the details." />}
      {settled && <Alert color={settled.color} role={settled.color === "success" ? "status" : "alert"} description={settled.text} />}
      {!checkout.orderMissing && !settled && !checkout.pollTimedOut && <Alert color="brand" description="Confirming your payment…" />}
      {!checkout.orderMissing && !settled && checkout.pollTimedOut && (
        <div>
          <Alert color="warning" description={PROCESSING_MESSAGE} />
          <div className="mt-2"><Button variant="secondary" onClick={() => checkout.pollStatus()}>Check again</Button></div>
        </div>
      )}
      {status && (
        <div className="pc-panel pc-confirmation mt-3">
          <p className="pc-eyebrow">{`Order #${status.order_number}`}</p>
          <ul className="pc-confirmation__attendees">
            {(status.attendees || []).map((name, index) => <li key={index}>{name}</li>)}
          </ul>
          <div className="pc-summary-row pc-summary-row--total">
            <span>Total</span>
            <span>{formatPrice(status.total, currencyCode)}</span>
          </div>
        </div>
      )}
      <div className="pc-checkout-actions pc-checkout-actions--start">
        {["failed", "released"].includes(checkout.settled)
          ? <Button as="a" variant="secondary" href={startOver}>Start Again</Button>
          : <Button as="a" variant="secondary" icon={ArrowLeft} href={classUrl}>Back to Class</Button>}
      </div>
    </div>
  );
}
